/**
    * @description      : 
    * @author           : Saif
    * @group            : 
    * @created          : 04/11/2024 - 21:20:25
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 04/11/2024
    * - Author          : Saif
    * - Modification    : 
**/
import { Route, Routes, BrowserRouter } from "react-router-dom";

import ForgetPassword from "../Screens/Auth/ForgetPassword";
import ForgetPassword2 from "../Screens/Auth/ForgetPassword2";
import ForgetPassword3 from "../Screens/Auth/ForgetPassword3";
import { Dashboard } from "../Screens/Dashboard";
import { UserManagement } from "../Screens/UserManagement";
import { AddUser } from "../Screens/UserManagement/AddUser";
import { EditUser } from "../Screens/UserManagement/EditUser";
import { UserDetails } from "../Screens/UserManagement/UserDetail";
import { TagManagement } from "../Screens/TagManagement";
import { CustomerSupport } from "../Screens/CustomerSupport";
import { AddMessage } from "../Screens/CustomerSupport/AddMessage";
import { EditMessage } from "../Screens/CustomerSupport/EditMessage";
import { MessageDetail } from "../Screens/CustomerSupport/MessageDetail";
import { ListingForm } from "../Screens/ListingManagement/AddListing";
import { CourseManagement } from "../Screens/CourseManagement";
import { AddCourse } from "../Screens/CourseManagement/AddCourse";
import { EditCourse } from "../Screens/CourseManagement/EditCourse";
import { CourseDetails } from "../Screens/CourseManagement/CourseDetail";
import { PromotionManagement } from "../Screens/PromotionManagement";
import { AddPromotion } from "../Screens/PromotionManagement/AddPromotion";
import { EditPromotion } from "../Screens/PromotionManagement/EditPromotion";
import { PromotionDetails } from "../Screens/PromotionManagement/PromotionDetail";
import { ReservationManagement } from "../Screens/ReservationrManagement";
import { ListingManagement } from "../Screens/ListingManagement";
// end

// New role-based pages
import { Wallet } from "../Screens/Wallet";
import { Invoice } from "../Screens/Invoice";
import { UserInvoice } from "../Screens/UserInvoice";
import { Billing } from "../Screens/Billing";

import Profile from "../Screens/Profile";
import EditProfile from "../Screens/Profile/EditProfile";
import ChangePassword from "../Screens/Profile/ChangePassword";
import { ProtectedRoutes } from "./ProtectedRoutes";
import VideoUploader from "../Screens/demo";
import FileUpload from "../Screens/demo/demo";
import Error from "../Screens/Error";
import { Favourite } from "../Screens/Favorite";
import { EditListingForm } from "../Screens/ListingManagement/EditNotification";

import { Home } from "../Screens/Home";
import { UnderConstruction } from "../Screens/Vacations/UnderConstruction";
import { VacationsHome } from "../Screens/Vacations/VacationsHome";
import { VacationsRegister } from "../Screens/Vacations/VacationsRegister";
import { VacationsLogin } from "../Screens/Vacations/VacationsLogin";
import { VacationsListings } from "../Screens/Vacations/VacationsListings";
import { SiteGate } from "../Components/SiteGate";
import { ListingDetail } from "../Screens/ListingDetail";
import { Search } from "../Screens/Search";
import { Terms } from "../Screens/Terms";
import { Privacy } from "../Screens/Privacy";
import { Sitemap } from "../Screens/Sitemap";

// Role-based route component
import { RoleBasedRoute } from "./RoleBasedRoute";
import Thankyou from "../Screens/Auth/ThankYou";
import { ReservationDetail } from "../Screens/ReservationrManagement/ReservationDetail";
import { DraftListingManagement } from "../Screens/ListingManagement/DraftListingManagement";

export default function AdminRouter() {
  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/" element={<UnderConstruction />} />
        <Route path="/login" element={<VacationsLogin />} />
        <Route path="/thank-you" element={<Thankyou />} />
        <Route path="/sign-up" element={<VacationsRegister />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/forget-password2" element={<ForgetPassword2 />} />
        <Route path="/forget-password3" element={<ForgetPassword3 />} />
        <Route path="/video" element={<ProtectedRoutes Components={VideoUploader} />} />
        <Route path="/video-upload" element={<ProtectedRoutes Components={FileUpload} />} />
        <Route path="/dashboard" element={<ProtectedRoutes Components={Dashboard} />} />

        {/* Host-only routes (role 2) */}
        <Route path="/wallet" element={<RoleBasedRoute Components={Wallet} allowedRoles={["2"]} />} />
        <Route path="/invoice" element={<RoleBasedRoute Components={Invoice} allowedRoles={["2"]} />} />
        <Route path="/add-listing" element={<RoleBasedRoute Components={ListingForm} allowedRoles={["2"]} />} />
        <Route path="/listing-management/edit-listing/:id" element={<RoleBasedRoute Components={EditListingForm} allowedRoles={["2"]} />} />
        <Route path="/listing-management" element={<RoleBasedRoute Components={ListingManagement} allowedRoles={["2"]} />} />
        <Route path="/draft-listings" element={<ProtectedRoutes Components={DraftListingManagement} allowedRoles={["2"]} />} />

        {/* Renter-only routes (role 3) */}
        <Route path="/user-invoice" element={<RoleBasedRoute Components={UserInvoice} allowedRoles={["3"]} />} />
        <Route path="/billing" element={<RoleBasedRoute Components={Billing} allowedRoles={["3"]} />} />

        {/* Shared routes for both roles */}
        <Route path="/reservation" element={<ProtectedRoutes Components={ReservationManagement} />} />
        <Route path="/reservation-management/reservation-details/:id" element={<ProtectedRoutes Components={ReservationDetail} />} />
        <Route path="/favorite" element={<ProtectedRoutes Components={Favourite} />} />
        <Route path="/profile/" element={<ProtectedRoutes Components={EditProfile} />} />
        <Route path="/change-password" element={<ChangePassword />} />

        {/* Admin-only routes (keeping existing admin routes) */}
        <Route path="/user-management" element={<ProtectedRoutes Components={UserManagement} />} />
        <Route path="/add-user" element={<ProtectedRoutes Components={AddUser} />} />
        <Route path="/edit-user" element={<ProtectedRoutes Components={EditUser} />} />
        <Route path="/user-management/user-details/:id" element={<ProtectedRoutes Components={UserDetails} />} />
        <Route path="/customer-support" element={<ProtectedRoutes Components={CustomerSupport} />} />
        <Route path="/add-message" element={<ProtectedRoutes Components={AddMessage} />} />
        <Route path="/edit-message" element={<ProtectedRoutes Components={EditMessage} />} />
        <Route path="/customer-support/message-details/:id" element={<ProtectedRoutes Components={MessageDetail} />} />

        {/* Public routes */}
        {/* Main site: password protected (SiteGate). Routes are case-insensitive so /Home works. */}
        <Route path="/home" element={<SiteGate><VacationsHome /></SiteGate>} />
        <Route path="/listings" element={<SiteGate><VacationsListings /></SiteGate>} />
        <Route path="/search" element={<SiteGate><Search /></SiteGate>} />
        <Route path="/listing-detial/:id" element={<SiteGate><ListingDetail /></SiteGate>} />
        <Route path="/terms" element={<SiteGate><Terms /></SiteGate>} />
        <Route path="/privacy" element={<SiteGate><Privacy /></SiteGate>} />
        <Route path="/sitemap" element={<SiteGate><Sitemap /></SiteGate>} />

        <Route path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
}
